import { render } from "./myBottom.vue?vue&type=template&id=f872a35a&scoped=true"
import script from "./myBottom.vue?vue&type=script&lang=js"
export * from "./myBottom.vue?vue&type=script&lang=js"

import "./myBottom.vue?vue&type=style&index=0&id=f872a35a&lang=scss&scoped=true"

import exportComponent from "E:\\Gitlab\\02_各园区PC端\\happyHarbour\\ningbo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f872a35a"]])

export default __exports__